<div class="event-filters d-block d-flex--md flexJustify-between col__">
  <div class="flex quicksearch--simple w-100 w-auto--md">
    <mat-form-field class="quicksearch--simple__input ongray w-100 w-auto--md">
      <mat-label>Search</mat-label>
      <input matInput [formControl]="eventSearchCtrl" type="search" autocomplete="off">
    </mat-form-field>
  </div>
  <mat-form-field class="flex ongray w-100 w-auto--md">
    <mat-label>Date range</mat-label>
    <mat-date-range-input [formGroup]="dateRangeFilter"
                          [rangePicker]="customDateRangePicker">
      <input matStartDate
             (blur)="onDateChange()"
             formControlName="start"
             placeholder="Start date">
      <input matEndDate
             (blur)="onDateChange()"
             formControlName="end"
             placeholder="End date">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix
                           [for]="customDateRangePicker"></mat-datepicker-toggle>
    <mat-date-range-picker #customDateRangePicker
                           (closed)="onDateChange()"></mat-date-range-picker>
  </mat-form-field>
</div>

<app-event-list-select [loading]="eventsLoading"
                       [events]="events"
                       [selectedEventIds]="selectedEventIds"
                       (selectedEvents)="onSelectionChanged($event)"
                       [allowSelectAll]="allowSelectAll"></app-event-list-select>
